"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enquireReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var EnquireState_init_1 = require("@/pages/common/states/EnquireState.init");
var EnquiryFormActions_1 = require("@/pages/common/actions/EnquiryFormActions");
exports.enquireReducer = function (state, action) {
    if (state === void 0) { state = EnquireState_init_1.defaultEnquireState; }
    switch (action.type) {
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.setEmailDisable): {
            return __assign(__assign({}, state), { disabled: __assign(__assign({}, state.disabled), { email: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.setFullNameError): {
            return __assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), { name: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.setPhoneError): {
            return __assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), { phone: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.setEmailError): {
            return __assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), { email: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.onFullNameChanged): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), { fullname: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.onPhoneChanged): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), { phone: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.onEmailChanged): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), { email: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.onCommentChanged): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), { comment: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.onSubscribeChanged): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), { update: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquiryFormActions_1.default.onCountryCodeChanged): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), { countryCode: action.payload }) });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setLoading): {
            return __assign(__assign({}, state), { isLoading: action.payload });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setEnquireDim): {
            return __assign(__assign({}, state), { isDim: action.payload });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setEnquireActive): {
            return __assign(__assign({}, state), { isActive: action.payload });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setCurrent): {
            return __assign(__assign({}, state), { current: action.payload });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setForm): {
            return __assign(__assign({}, state), { enquiry: __assign(__assign({}, state.enquiry), action.payload) });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setReplybar): {
            return __assign(__assign({}, state), { replybar: action.payload });
        }
        case typesafe_actions_1.getType(EnquireAction_1.default.setLastEnquiry): {
            return __assign(__assign({}, state), { lastEnquiry: action.payload });
        }
    }
    return state;
};
